import { render, staticRenderFns } from "./importGeojson.vue?vue&type=template&id=01fb2f33&scoped=true"
import script from "./importGeojson.vue?vue&type=script&lang=js"
export * from "./importGeojson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fb2f33",
  null
  
)

export default component.exports